<template>
  <div>
    <div class="sayfabaslik">
      <div class="text">
        <div class="el-button-group">
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/muhasebe/ekran" type="default"> Ekran
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/muhasebe/bina" type="default"> Bina Liste
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/muhasebe/fatura" type="default"> Faturalandırma
          </router-link>
          <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                       to="/muhasebe/rapor" type="default"> Alacak Raporu
          </router-link>

        </div>
      </div>
    </div>
    <router-view></router-view>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Muhasebe/Index.vue